import {
	getAttributes,
	addAttribute,
	deleteAttribute,
	updateAttribute,
	updateAppAttributesList,
	updateApkAttributesList,
	updateCompanyAttributesList,
	updateStoreAttributesList,
	updatePocketAttributesList,
	updateUserAttributesList
} from '../helpers/attributesService';
import {checkError, receiveErrorAlert, closeAlert, receiveSuccessAlert} from './commonsActions';
import { getOneApp } from './marketActions';

/*
 * action types
 */
export const FETCH_ATTRIBUTES_BEGIN   = 'GET_ATTRIBUTES_BEGIN';
export const GET_ATTRIBUTES = 'GET_ATTRIBUTES';
export const GET_FILTERED_ATTR = 'GET_FILTERED_ATTR';

/*
 * action creators
 */

export const fetchAttributesBegin = () => ({
	type: FETCH_ATTRIBUTES_BEGIN
});

export const getAttributesList = attributes => ({
	type: GET_ATTRIBUTES,
	payload: {
		attributes
		//numberOfElements : attributes.numberOfElements,
		//totalElements: attributes.totalElements,
		//totalPages: attributes.totalPages
	}
});

export const fetchAttributes = (query) => dispatch => {
	dispatch(fetchAttributesBegin());
	return getAttributes(query).then(res => {
			dispatch(getAttributesList(res.data));
			if (query && query.filter) {
				dispatch(filteringAttr(query.filter));
			} else {
				dispatch(filteringAttr());
			}
		}, error => {
			dispatch(checkError(error));
			dispatch(receiveErrorAlert(error));
			setTimeout(() => {
				dispatch(closeAlert());
			}, 2000);
		})
};

export const filteringAttr = filter => (dispatch, getState) => {
	const state = getState();
	let filteredAttrs = state.attributesList.attributes;

	if (filter) {
		filter.forEach(item => {
			filteredAttrs = filteredAttrs.filter( attr => {
				if (item.value && item.value !== '') {
				    return attr[item.name].toLowerCase().indexOf(item.value.toLowerCase()) !== -1;
				} else {
					return true;
				}
			});
		})
	} else {
		filteredAttrs = state.attributesList.attributes;
	}
	dispatch({
		type: GET_FILTERED_ATTR,
		attributes: filteredAttrs
	});
};

export const saveNewAttribute = newAttribute => dispatch => {
	return addAttribute({
		name: newAttribute.name,
		defaultValue: newAttribute.defaultValue,
		permittedValues: newAttribute.permittedValues,
		type: newAttribute.type,
		valueType: newAttribute.valueType,
		visibleForCompanies: newAttribute.visibleForCompanies,
		editableByCompany: newAttribute.editableByCompany,
		xpathMapping: newAttribute.xpathMapping,
		comments: newAttribute.comments,
		label: newAttribute.label

	}).then(res => {
		//dispatch(fetchAttributes());
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})

};

export const updateOldAttribute = attribute => dispatch => {
	return updateAttribute({
			id: attribute.id,
			name: attribute.name,
			defaultValue: attribute.defaultValue,
			permittedValues: attribute.permittedValues,
			type: attribute.type,
			visibleForCompanies: attribute.visibleForCompanies,
			editableByCompany: attribute.editableByCompany,
			valueType: attribute.valueType,
			xpathMapping: attribute.xpathMapping,
			comments: attribute.comments,
			label: attribute.label
		}).then(res => {
		//dispatch(fetchAttributes());
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})

};

export const deleteAttr = attributeId => dispatch => {
	return deleteAttribute(attributeId).then(res => {
		// dispatch(fetchAttributes());
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const updateAppAttributes = (attributes, activeAppId) => dispatch => {
	return updateAppAttributesList(attributes).then(res => {
		dispatch(getOneApp(activeAppId));
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const updateApkAttributes = (attributes, activeAppId) => dispatch => {
	return updateApkAttributesList(attributes).then(res => {
		dispatch(getOneApp(activeAppId));
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const updateCompanyAttributes = (attributes) => dispatch => {
	return updateCompanyAttributesList(attributes).then(res => {
		dispatch(receiveSuccessAlert('Update Successful'));
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const updateStoreAttributes = (attributes) => dispatch => {
	return updateStoreAttributesList(attributes).then(res => {
		dispatch(receiveSuccessAlert('Update Successful'));
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const updatePocketAttributes = (attributes) => dispatch => {
	return updatePocketAttributesList(attributes).then(res => {
		dispatch(receiveSuccessAlert('Update Successful'));
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const updateUserAttributes = (attributes) => dispatch => {
	return updateUserAttributesList(attributes).then(res => {
		dispatch(receiveSuccessAlert('Update Successful'));
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};



// WEBPACK FOOTER //
// ./src/actions/attributesActions.js